import {useSelector} from 'react-redux';
import {useRoute} from '@react-navigation/native';

import {
  REPORT_ALL_FRONTLINE_ORDERS,
  REPORT_ALL_GEN0_ORDERS,
  REPORT_ALL_ORDERS,
  REPORT_ALL_ORGANIZATION_ORDERS,
} from '/enum/records.enum';
import {EVENT_NAMES} from '/enum/tealium.enum';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {DashboardMetricCardHookProps} from './DashboardMetricCard.types';

export const REPORT_NAME = {
  ['Frontline Qualifying Volume']: REPORT_ALL_FRONTLINE_ORDERS,
  ['Generation 0 Volume']: REPORT_ALL_GEN0_ORDERS,
  ['Total Generation Volume']: REPORT_ALL_ORGANIZATION_ORDERS,
};
export const REPORT_NAME_Phase2 = {
  ['Frontline Qualifying Volume']: REPORT_ALL_ORDERS,
  ['Generation 0 Volume']: REPORT_ALL_ORDERS,
  ['Total Generation Volume']: REPORT_ALL_ORDERS,
};
export const useDashboardMetricCard = ({
  analyticsHeading = '',
  infoPopOverHeading = '',
  infoPopOverBody = '',
  onShowInfoPopover = () => {},
  onShowReport = () => {},
  lastPaidRank = '',
}: DashboardMetricCardHookProps) => {
  const {name} = useRoute();
  const featureFlag = useSelector(variablesFeatureFlag);

  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.informationClick,
  });

  const onInfoPress = () => {
    onShowInfoPopover({
      heading: infoPopOverHeading,
      body: infoPopOverBody,
    });

    sendEvent({
      buttonName: analyticsHeading,
      screenName: name,
      lastPaidRank: lastPaidRank,
    });
  };

  const onCardPress = (heading: string) => {
    if (featureFlag.ACTIVE_Phase2) {
      onShowReport({
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        recordsName: REPORT_NAME_Phase2[heading],
        reportHeading: heading,
      });
    } else {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      onShowReport({recordsName: REPORT_NAME[heading]});
    }
  };

  return {
    onInfoPress,
    onCardPress,
  };
};
